module.exports = __webpack_public_path__ + "media/images/homepage/video-poster-289615e89eb7a59deb22998859d41d49.png";